import React from "react";
import { Modal } from "react-bootstrap";

export const LogoutBox = ({ show, onHide, onLogout }) => {
	return (
		<Modal show={show} onHide={() => onHide()} dialogClassName="modal-s modal-confirm">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Đăng xuất</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-confirm-body">
					<p className="font-14">Bạn chắc chắn muốn đăng xuất không?</p>
					<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" onClick={onLogout}>
							Đăng xuất
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};
